var $ = require('jquery');
var TorsoModel = require('backbone-torso/modules/Model');
var urls = require('./../urls');

/**
 * Model used to authenticate a portal user by username and password.
 *
 * @class AuthModel
 * @constructor
 */
module.exports = TorsoModel.extend({
  urlRoot: urls.portalAuthenticationExtService,

  /**
   * @method save
   * @override
   * Throws a not implemented error if called. Use authenticate instead
   */
  save: function() {
    throw 'Save not implemented, use AuthModel.authenticate';
  },

  /**
   * Attempts to authenticate the portal user.
   * This method is extracted from the standard backbone save() because it is not
   * following the methodology of saving an instance of an object on the server, rather it
   * is just checking the validity of the data.
   * Separating this allows us to use the server response without having to go through the model.
   *
   * @method authenticate
   */
  authenticate: function() {
    return $.ajax({
      method: 'POST',
      url: this.urlRoot,
      data: JSON.stringify(this.toJSON()),
      contentType: 'application/json;charset=utf-8'
    });
  }
});
